import React from 'react';
export function InstituteLegalFooter() {
  return <footer className="w-full bg-navy-900 text-gray-300 py-12 px-4 border-t-4 border-gold-600" data-id="element-52">
      <div className="max-w-4xl mx-auto space-y-8 text-center" data-id="element-53">
        <div className="space-y-2" data-id="element-54">
          <h4 className="text-lg md:text-xl font-serif font-bold text-white tracking-wide" data-id="element-55">
            Instituto Americano de Estudios en Vínculos Emocionales y Bienestar
            Relacional
          </h4>
          <p className="text-sm text-gray-400 font-mono" data-id="element-56">
            Operado por: Templo de Ayuda La Luz Del Mundo — Miami, Florida —
            Desde 1945
          </p>
        </div>

        <div className="border-t border-gray-700 pt-8" data-id="element-57">
          <p className="text-xs md:text-sm text-gray-500 leading-relaxed max-w-3xl mx-auto text-justify" data-id="element-58">
            <strong className="text-gray-400 uppercase tracking-wider" data-id="element-59">
              AVISO LEGAL:
            </strong>{' '}
            La evaluación inicial brindada por nuestros especialistas
            espirituales no tiene costo. Los trabajos espirituales tienen un
            valor asociado a la adquisición de materiales naturales, el cual
            será informado previamente. Los resultados pueden variar según cada
            persona. Estos servicios son alternativos y no sustituyen atención
            médica, psicológica o psiquiátrica. Dirigido exclusivamente a
            mayores de edad.
          </p>
        </div>
      </div>
    </footer>;
}